// extracted by mini-css-extract-plugin
export var completionBody = "_jn-2";
export var completionCard = "_jn-0";
export var completionFooter = "_jn-3";
export var completionTitle = "_jn-1";